import React from 'react'
import type { TFunction } from 'i18next'
import { dismissToast } from '@/src/renderer/components/common/MessageToast'
import { showSuccessToast } from '@/src/renderer/components/common/SuccessToast'
import { RecurringIcon } from '@/src/renderer/components/icons/RecurringIcon'
import type { Task } from '@/src/renderer/lib/db/models'
import { comebackMessage } from './comebackMessage'

/**
 * Abgehakt → der „Kommt wieder"-Toast, der dazu gehört. Nur für diese Sitzung, wie die
 * Nachfolger-Map in `spawnNextOccurrence`: Der Haken zurück schließt ihn wieder.
 */
const shown = new Map<string, string>()

/**
 * **„Kommt wieder …"** für Aufgaben und Unteraufgaben (#213) — ein Toast für alle, die auf einmal
 * abgehakt wurden. `completedIds`: die abgehakten, deren Haken zurück ihn wieder wegnimmt.
 */
export function showComebackToast(
  successors: readonly Pick<Task, 'startDate' | 'recurrence' | 'title'>[],
  completedIds: readonly string[],
  t: TFunction,
  locale: string,
  now: Date,
): void {
  const message = comebackMessage(successors, t, locale, now)
  if (!message) return
  // Darunter die Aufgabe (#223) — bei mehreren sagt der Satz schon „3 Aufgaben kommen wieder“.
  const description = successors.length === 1 ? successors[0]!.title : undefined
  const toastId = showSuccessToast({ message, description, icon: React.createElement(RecurringIcon, { size: 18 }), tone: 'recurring' })
  for (const id of completedIds) shown.set(id, toastId)
}

/** Der Haken zurück: Sein „Kommt wieder …" stimmt nicht mehr. */
export function dismissComebackToast(id: string): void {
  const toastId = shown.get(id)
  if (!toastId) return
  shown.delete(id)
  dismissToast(toastId)
}
